import React from "react";
import parlour from "../assets/img/cart/parlour.PNG";
import SEO from "./Common/SEO";

const About = () => {
  return (
    <div>
      <SEO 
        title="About Us | Specialized Cart Manufacturers"
        description="Learn more about Cart Studio, India's trusted manufacturer of custom tricycle carts, rickshaws, and e-carts for brands like Amul and Kwality Wall's."
      />
      <div className="py-6 lg:py-6 px-4">
        <section id="about">
          {/* Section Title */}
          <div className=" section-title p-1" data-aos="fade-up">
            <span className="subtitle">About Us</span>
            <h1>WE DESIGN & MANUFACTURE CUSTOM CARTS</h1>
          </div>
          {/* End Section Title */}
          <div className="container">
            <div data-aos="fade-up" data-aos-delay="100">
              <div className="flex flex-col lg:flex-row items-start gap-10">
                {/* Left Content */}
                <div
                  className="w-full lg:w-1/2"
                  data-aos="fade-right"
                  data-aos-delay="200"
                >
                  <div className="space-y-5 italic leading-7  md:text-xl ">
                    {/* Quote Icon */}
                    <div
                      className="w-[60px] h-[60px] flex items-center justify-center rounded-full mb-6 text-[1.75rem]"
                      style={{
                        backgroundColor:
                          "color-mix(in srgb, #c85716, transparent 90%)",
                        color: "#c85716",
                      }}
                    >
                      <i className="bi bi-quote"></i>
                    </div>

                    {/* Paragraphs */}
                    {/* <p>
                      We introduce ourselves as a leading manufacturer of
                      tricycle carts, tricycle rickshaws, e-carts, and
                      e-rickshaws, specializing in all types of Ice Cream Carts.
                    </p> */}

                    <p>
                      CART STUDIO is a leading manufacturer of Tricycle Carts,
                      Tricycle Rickshaws, E-Carts, and E-Rickshaws, with a
                      strong specialization in Ice Cream Carts. Recognized for
                      our innovative designs and reliable quality, we have
                      partnered with some of the most renowned names in the ice
                      cream industry, including Mother Dairy, Hindustan Unilever
                      (Kwality Walls & Magnum), Creambell, Vadilal, London
                      Dairy, Namaste India, and many more.
                    </p>

                    <p>
                      Our advanced production facility combines high-tech
                      machinery, modern manufacturing methods, and premium-grade
                      components to deliver carts and vehicles designed for
                      performance, durability, and sustainability. CART STUDIO
                      vehicles are widely used for:
                    </p>

                    {/* Bullet List */}
                    <ul className="list-disc list-inside space-y-1 text-gray-700">
                      <li>Non-polluting, eco-friendly people movement</li>
                      <li>Efficient and reliable goods transfer</li>
                      <li>Local, rural, and inner-city transportation</li>
                      <li>Environmental waste collection and movement</li>
                      <li>Noise-free and sustainable mobility solutions</li>
                    </ul>

                    <p>
                      What sets us apart is our manufacturing excellence, strong
                      marketing approach, and innovative product development
                      strategy. These strengths have earned us recognition
                      across India and helped establish CART STUDIO as an
                      industry leader.
                    </p>
                    <p>
                      We remain committed to providing the highest quality
                      products, backed by dependable after-sales service,
                      ensuring long-term value and trust for our customers.
                    </p>
                  </div>
                </div>

                {/* Right Image */}
                <div
                  className="w-full lg:w-[40%] py-10"
                  data-aos="fade-left"
                  data-aos-delay="300"
                >
                  <div className="overflow-hidden rounded-lg shadow-lg transform transition duration-300 hover:scale-105 ">
                    <img
                      src={parlour}
                      alt="About us"
                      className="w-full max-h-[400px] object-fit"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
